import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { channelsRoutes } from './channels.routes';

import { ChannelListComponent } from './channel-list/channel-list.component';
import { CreateChannelComponent } from './create-channel/create-channel.component';
import { ChannelIdentityTabComponent } from './components/channel-identity-tab/channel-identity-tab.component';
import { ChannelFieldRulesTabComponent } from './components/channel-field-rules-tab/channel-field-rules-tab.component';
import { ChannelSurveysTabComponent } from './components/channel-surveys-tab/channel-surveys-tab.component';
import { ChannelSkuRulesTabComponent } from './components/channel-sku-rules-tab/channel-sku-rules-tab.component';
import { ChannelImpactPreviewTabComponent } from './components/channel-impact-preview-tab/channel-impact-preview-tab.component';

@NgModule({
  declarations: [
    ChannelListComponent,
    CreateChannelComponent,
    ChannelIdentityTabComponent,
    ChannelFieldRulesTabComponent,
    ChannelSurveysTabComponent,
    ChannelSkuRulesTabComponent,
    ChannelImpactPreviewTabComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(channelsRoutes),
    SharedModule
  ]
})
export class ChannelsModule { }
